import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  DRAG_FILES_HERE,
  UPLOAD,
  INVALID_FILE_TYPE,
} from "../../../i18n/keyConstants";
import { CloseButton } from "react-bootstrap";

const ExlFileUploadModal = ({
  description,
  teacher,
  open,
  onClose,
  handleAdd,
}) => {
  // ------------------------ States
  const [file, setFile] = useState(false);
  const [showError, setShowError] = useState(false);

  // ------------------------ Methods

  const onCancel = () => {
    onClose();
  };

  const dragOverHandler = (ev) => {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();
  };

  const handleFileChange = (ev) => {
    ev.preventDefault();

    let selectedFile = ev.dataTransfer?.files[0] || ev.target.files[0];

    if (selectedFile) {
      // Check the file type
      const fileType = selectedFile.type;
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "text/plain",
      ];

      if (allowedTypes.includes(fileType)) {
        setFile(selectedFile);
        setShowError(false);
      } else {
        setShowError(true);
        setFile(null); // Reset the file state if the type is not allowed
      }
    }
  };

  const { t } = useTranslation(["shared"]);

  return (
    <>
      <Modal
        show={open}
        onHide={onCancel}
        className={"d-flex flex-col align-items-center justify-content-center"}
      >
        <div className="add-item-form container">
          <div className="d-flex justify-content-between align-items-center m-3 border-bottom font-weight-bold">
            <div className=" user-select-none p-1">{description}</div>
            <CloseButton onClick={onCancel} className="px-1 pb-1 mb-1" />
          </div>
          <Modal.Body className="container">
            <div>
              <div onDrop={handleFileChange} onDragOver={dragOverHandler}>
                <label
                  className="exl-file-input user-select-none"
                  htmlFor="exl-file"
                >
                  {t(DRAG_FILES_HERE)}
                </label>
                <input
                  style={{ display: "none" }}
                  type="file"
                  id="exl-file"
                  name="exl-file"
                  onChange={handleFileChange}
                />
              </div>

              <div className="d-flex flex-column w-100">
                <div className="w-100">
                  <div className="flex-column mb-1 badge">PDF/DOCX/DOC/TXT</div>
                  <div className="d-flex flex-column w-100">
                    {showError ? (
                      <span className="text-danger text-white mb-1">
                        {t(INVALID_FILE_TYPE).toUpperCase()}
                      </span>
                    ) : (
                      <span
                        style={{
                          fontSize: "1rem",
                          padding: "0.6rem",
                          marginRight: "1rem",
                        }}
                        className="badge bg-light text-dark"
                      >
                        {getFormattedFileName(file?.name)}
                      </span>
                    )}
                    <button
                      onClick={() => {
                        handleAdd(file, teacher.id);
                        setFile(null);
                      }}
                      className="btn btn-primary"
                      type="button"
                      disabled={!file}
                    >
                      {t(UPLOAD)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default ExlFileUploadModal;

const getFormattedFileName = (fileName) => {
  if (!fileName) return "";

  const maxLength = 20;
  const extension = fileName.substring(fileName.lastIndexOf("."));

  if (fileName.length > maxLength) {
    return `${fileName.substring(0, maxLength)}...${extension}`;
  }

  return fileName;
};
